export default __webpack_public_path__ + "static/404@3x-1660bb00e80330feea4e19645c1a6ce8.png";